/* Copyright (c) 2023 CLOUDPILOTS Software & Consulting GmbH */

import defaultTheme from '@cloudpilots/components/core/theme';
import { createMuiTheme } from '@material-ui/core/styles';
import deepmerge from 'deepmerge';
import { useMemo } from 'react';
import customTheme from '../theme';

const useTheme = () => {
  const theme = useMemo(() => {
    const mergedThemes = deepmerge(defaultTheme, customTheme);
    const muiTheme = createMuiTheme(mergedThemes);
    return muiTheme;
  }, []);
  return theme;
};

export { useTheme as default };
